import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import { useFetchGetV2 } from "hooks/fetch/useFetchGetV2";
import { SettingsSection } from "components/Settings/SettingsSection";
import { Link } from "react-router-dom";
import { useLoadCounter } from "hooks/useLoadCounter";

export const MachineModelSection = () => {
  const {
    loading: machineModelsLoading,
    error: machineModelsError,
    response: machineModelsResponse
  } = useFetchGetV2("machine_models?ordering=id");
  const tableLoadCount = useLoadCounter(machineModelsLoading);

  if (machineModelsLoading) {
    return <></>;
  }

  if (machineModelsError) {
    return <></>;
  }

  if (machineModelsResponse) {
    return (
      <>
        <SettingsSection title="Machine Models">
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell data-col={1}>ID</TableCell>
                  <TableCell data-col={2}>Name</TableCell>
                  <TableCell data-col={3}>Manufacturer</TableCell>
                </TableRow>
              </TableHead>
              <TableBody
                data-qa_loading={machineModelsLoading}
                data-qa_load_count={tableLoadCount}
              >
                {machineModelsResponse &&
                  machineModelsResponse?.results.map(machine_model => (
                    <TableRow key={machine_model.id}>
                      <TableCell data-col={1}>{machine_model.id}</TableCell>
                      <TableCell data-col={2}>
                        <Link
                          to={`/pages/settings/machine_model/${machine_model.id}`}
                        >
                          {`${machine_model.name}`}
                        </Link>
                      </TableCell>
                      <TableCell data-col={3}>
                        {`${machine_model.manufacturer}`}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </SettingsSection>
      </>
    );
  }
};
